'use client'

import { createContext, useContext, useState } from 'react'
import useSWR from 'swr'

type DataStoreContext = ReturnType<typeof useDataStoreProviderFactory>

const DataStoreContext = createContext({} as DataStoreContext)

export const useDataStore = () => useContext(DataStoreContext)

export const DataStoreProvider = ({ ...props }) => {
  const value = useDataStoreProviderFactory()
  return <DataStoreContext.Provider value={value} {...props} />
}

const useDataStoreProviderFactory = () => {
  // states
	const [pinIntro, setPinIntro] = useState(true)

  // hooks
  const sessionSWR = useSWR(`/self-serve/ivr/card-portal/session`)
  
  const transactionsSWR = useSWR(`/self-serve/customer-portal/transactions`)

  // disclosures

  // computed

  // helpers
	const dismissIntro = () => setPinIntro(false)

  return {
    session: sessionSWR,
    transactions: transactionsSWR,
		showPinIntro: pinIntro,
		dismissIntro
  }
}
